interface StandaloneNavigator {
  standalone?: boolean;
}

export function isPwaStandalone(input?: {
  displayModeStandalone: boolean;
  navigator: StandaloneNavigator;
}): boolean {
  if (input) return input.displayModeStandalone || input.navigator.standalone === true;
  if (typeof window === "undefined") return false;

  return (
    window.matchMedia("(display-mode: standalone)").matches ||
    (navigator as StandaloneNavigator).standalone === true
  );
}
